import {Box} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {
	BOX_SHADOWS,
	DATA_TYPES,
	FONTS,
	PAIR_PLOT_RADIALS,
	PRIMARY_COLOR,
} from "../../constants";
import {stateType, stateTypeF} from "../../state";
import {DualChart} from "./DualChart";

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import {KeyboardArrowDown} from "@material-ui/icons";
import React from "react";
import {trimString} from "../Common/helpers";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		listRoot: {
			width: "100%",
			backgroundColor: theme.palette.background.paper,
			position: "relative",
			height: "100%",
			overflow: "auto",
			fontFamily: FONTS,
		},
		container: {
			boxShadow: BOX_SHADOWS,
			backgroundColor: "white",
			height: "510px",
			width: "70%",
			display: "flex",
			flexDirection: "column",
			fontFamily: FONTS,
			borderRadius: "10px",
			overflow: "hidden",
		},
		listContainer: {
			marginTop: "5px",
			display: "flex",
			flexDirection: "row",
			height: "90%",
			fontFamily: FONTS,
			width: "100%",
		},
		catIcons: {
			width: "30px",
			height: "30px",
			backgroundColor: PRIMARY_COLOR,
			borderRadius: "5px",
			textAlign: "center",
			fontWeight: "bold",
			lineHeight: "30px",
			marginRight: "5px",
			color: "white",
			marginLeft: "20px",
		},
		colTitle: {width: "100%", textAlign: "center"},
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
		selectEmpty: {
			marginTop: theme.spacing(2),
		},
		dropDownText: {},
		dropDown: {
			width: "140px",
			height: "30px",
			border: "solid",
			marginLeft: "20px",
			borderRadius: "5px",
			borderColor: "rgba(0,0,0,0.2)",
			borderWidth: "2px",
			marginTop: "-5px",
			display: "flex",
			flexDirection: "row",
			transition: "0.3s",
			cursor: "pointer",
			backgroundColor: "white",
			"&:hover": {backgroundColor: "rgba(0,0,0,0.1)"},
			fontFamily: FONTS,
		},
		root: {
			width: 300,
		},
	})
);

type dropDownType = {state: stateTypeF; i: number};

export function DropDown({state, i}: dropDownType) {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuSelect = (value) => {
		let tmp = state.saveState.correlations.dualChartSelected;
		tmp[i] = value;
		state.saveState.correlations.dualChartSelected = tmp;
		state.setSaveState(state.saveState);
		setAnchorEl(null);
	};

	let colNames: string[] = [];

	for (let col of state.saveState.dataset.columns) {
		if (col.columnType !== DATA_TYPES.unusable) {
			colNames.push(col.columnName);
		}
	}
	colNames = colNames.sort((a, b) =>
		a.toLowerCase() < b.toLowerCase() ? -1 : 1
	);

	return (
		<div className={classes.dropDown}>
			<div
				onClick={(event: any) => handleClick(event)}
				style={{
					width: "100%",
					height: "100%",
					textAlign: "left",
					lineHeight: "30px",
					marginLeft: "10px",
				}}
			>
				{trimString(
					state.saveState.correlations.dualChartSelected[i],
					11
				)}
			</div>
			<KeyboardArrowDown
				style={{
					marginTop: "4px",
					width: "22px",
					height: "22px",
					left: "-4px",
				}}
			></KeyboardArrowDown>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{
					marginTop: "43px",
					marginLeft: "-90px",
					maxWidth: "400px",
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
			>
				{colNames.map((colName) => (
					<MenuItem
						style={{width: "190px"}}
						onClick={() => handleMenuSelect(colName)}
						id={trimString(colName, 11)}
						value={colName}
					>
						{colName}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}
export function RadioButtonsGroup({state}: stateType) {
	const [value, setValue] = React.useState(state.plotRadialsSelected);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		state.setPlotRadialsSelected((event.target as HTMLInputElement).value);
		setValue((event.target as HTMLInputElement).value);
	};

	return (
		<div
			style={{
				width: "100%",
				position: "relative",
				justifyContent: "center",
				marginTop: "430px",
				alignContent: "center",
			}}
		>
			<FormControl component="fieldset">
				<RadioGroup
					aria-label="Display"
					name="gender1"
					value={value}
					onChange={handleChange}
					row
				>
					<FormControlLabel
						value="Counts"
						control={
							<Radio
								style={{marginRight: "-5px"}}
								size="small"
							/>
						}
						label={
							<div
								style={{
									fontSize: 16,
									fontFamily: FONTS,
									color: "rgba(0,0,0,0.6)",
								}}
							>
								{PAIR_PLOT_RADIALS.counts}
							</div>
						}
					/>
					<FormControlLabel
						value="Percentage"
						control={
							<Radio
								style={{marginRight: "-5px"}}
								size="small"
							/>
						}
						label={
							<div
								style={{
									fontSize: 16,
									fontFamily: FONTS,
									color: "rgba(0,0,0,0.6)",
								}}
							>
								{PAIR_PLOT_RADIALS.percentage}
							</div>
						}
					/>
					<FormControlLabel
						value="Total Percentage"
						control={
							<Radio
								style={{marginRight: "-5px"}}
								size="small"
							/>
						}
						label={
							<div
								style={{
									fontSize: 16,
									fontFamily: FONTS,
									color: "rgba(0,0,0,0.6)",
								}}
							>
								{PAIR_PLOT_RADIALS.total_percent}
							</div>
						}
					/>
				</RadioGroup>
			</FormControl>
		</div>
	);
}

export function ChooseVarsBox({state}: stateType) {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<DualChart state={state}></DualChart>
		</div>
	);
}
